import '../../_rollupPluginBabelHelpers-1f0bf8c2.js';
export { unstable_getIn } from './getIn.js';
import 'reakit-utils/isObject';
export { unstable_setAllIn } from './setAllIn.js';
import 'reakit-utils/toArray';
import 'reakit-utils/isInteger';
export { unstable_setIn } from './setIn.js';
